import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4014ea5a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "tw-document-wrapper z-top controls-background" }
const _hoisted_3 = { class: "card-header bg-white d-flex justify-content-between align-items-center pl-3 pr-2" }
const _hoisted_4 = { class: "card-title mb-0 d-flex align-items-center" }
const _hoisted_5 = { class: "font-weight-bold" }
const _hoisted_6 = { class: "card-title mb-0 d-flex align-items-end" }
const _hoisted_7 = { class: "row card-body tw-document-container" }
const _hoisted_8 = {
  key: 0,
  class: "tw-global-spinner z-top position-absolute"
}
const _hoisted_9 = {
  key: 1,
  class: "col-12"
}
const _hoisted_10 = { class: "col-12 mb-3 p-3 bg-light default-border-radius" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-3" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block mb-0 text-muted font-size-12" }, "VIN / Châssis", -1))
const _hoisted_14 = { class: "font-weight-bold" }
const _hoisted_15 = { class: "col-3" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block mb-0 text-muted font-size-12" }, "Commande", -1))
const _hoisted_17 = { class: "font-weight-bold" }
const _hoisted_18 = { class: "col-3" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block mb-0 text-muted font-size-12" }, "Créé le (e-Flo)", -1))
const _hoisted_20 = { class: "font-weight-bold" }
const _hoisted_21 = { class: "col-3" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block mb-0 text-muted font-size-12" }, "Vérifié le", -1))
const _hoisted_23 = { class: "font-weight-bold" }
const _hoisted_24 = {
  key: 0,
  class: "text-deep-black-4 font-weight-normal mt-3"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-warning" }, "⚠️ Aucun VIN renseigné pour ce véhicule.", -1))
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = {
  key: 1,
  class: "text-deep-black-4 font-weight-normal mt-3"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-success" }, "Aucun OTS trouvé pour ce véhicule.", -1))
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = {
  key: 2,
  class: "col-12 pr-2 pl-2 pt-2 default-border-radius"
}
const _hoisted_31 = { class: "mb-2" }
const _hoisted_32 = { class: "font-weight-bold" }
const _hoisted_33 = { class: "row" }
const _hoisted_34 = { class: "col-lg-3 d-flex flex-column" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block mb-1 text-muted font-size-11" }, "Code OTS", -1))
const _hoisted_36 = { class: "d-flex align-items-center" }
const _hoisted_37 = { class: "font-size-13 mr-2" }
const _hoisted_38 = { class: "font-weight-bold" }
const _hoisted_39 = { class: "col-lg-9 d-flex flex-column" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block mb-1 text-muted font-size-11" }, "Libellé", -1))
const _hoisted_41 = { class: "font-size-13 font-weight-medium" }
const _hoisted_42 = { class: "row mt-2" }
const _hoisted_43 = { class: "col-12" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block mb-1 text-muted font-size-11" }, "Description / Action", -1))
const _hoisted_45 = { class: "p-2 bg-white default-border-radius border-dashed" }
const _hoisted_46 = { class: "font-size-12" }
const _hoisted_47 = { class: "row mt-2" }
const _hoisted_48 = { class: "col-lg-3 d-flex flex-column" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block mb-0 text-muted font-size-11" }, "Code Couleur", -1))
const _hoisted_50 = { class: "col-lg-3 d-flex flex-column" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block mb-0 text-muted font-size-11" }, "Note Technique", -1))
const _hoisted_52 = { class: "font-size-12 font-weight-medium" }
const _hoisted_53 = { class: "col-lg-3 d-flex flex-column" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block mb-0 text-muted font-size-11" }, "Quotation", -1))
const _hoisted_55 = { class: "font-size-12 font-weight-medium" }
const _hoisted_56 = { class: "col-lg-3 d-flex flex-column" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block mb-0 text-muted font-size-11" }, "Accord Garantie", -1))
const _hoisted_58 = { class: "font-size-12 font-weight-medium" }
const _hoisted_59 = { class: "row mt-2" }
const _hoisted_60 = { class: "col-lg-6 d-flex flex-column" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block mb-0 text-muted font-size-11" }, "Pays de Livraison", -1))
const _hoisted_62 = { class: "font-size-12 font-weight-medium" }
const _hoisted_63 = { class: "col-lg-6 d-flex flex-column" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block mb-0 text-muted font-size-11" }, "Date Livraison", -1))
const _hoisted_65 = { class: "font-size-12 font-weight-medium" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_spinner_facebook = _resolveComponent("q-spinner-facebook")!
  const _component_q_chip = _resolveComponent("q-chip")!

  return (_ctx.toggleShow)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("span", _hoisted_5, _toDisplayString(`OTS - ${_ctx.orderReference || 'Commande'}`), 1)
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_q_icon, {
                  name: "chevron_right",
                  size: "20px",
                  onClick: _ctx.toggleShowControls,
                  class: "cursor-pointer"
                }, null, 8, ["onClick"])
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              (_ctx.loading === true)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createVNode(_component_q_spinner_facebook, {
                      size: "3em",
                      color: "primary"
                    })
                  ]))
                : _createCommentVNode("", true),
              (_ctx.loading === false)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                          _hoisted_13,
                          _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.vin || 'Non renseigné'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_15, [
                          _hoisted_16,
                          _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.orderReference || '-'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_18, [
                          _hoisted_19,
                          _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.createdDate || '-'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_21, [
                          _hoisted_22,
                          _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.lastCheckDate || '-'), 1)
                        ])
                      ])
                    ]),
                    (!_ctx.vin)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_24, _hoisted_26))
                      : (_ctx.otsData && _ctx.otsData.totalElements === 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_27, _hoisted_29))
                        : (_ctx.otsData && _ctx.otsData.data && _ctx.otsData.data.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                              _createElementVNode("div", _hoisted_31, [
                                _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.otsData.totalElements) + " OTS trouvé" + _toDisplayString(_ctx.otsData.totalElements > 1 ? 's' : ''), 1)
                              ]),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.otsData.data, (ots, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: index,
                                  class: _normalizeClass(["col-12 p-3 mb-2 ots-item-card", _ctx.getColorClass(ots.colorCode)])
                                }, [
                                  _createElementVNode("div", _hoisted_33, [
                                    _createElementVNode("div", _hoisted_34, [
                                      _hoisted_35,
                                      _createElementVNode("div", _hoisted_36, [
                                        _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.getSeverityIcon(ots.colorCode)), 1),
                                        _createElementVNode("span", _hoisted_38, _toDisplayString(ots.code), 1)
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_39, [
                                      _hoisted_40,
                                      _createElementVNode("span", _hoisted_41, _toDisplayString(ots.label), 1)
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_42, [
                                    _createElementVNode("div", _hoisted_43, [
                                      _hoisted_44,
                                      _createElementVNode("div", _hoisted_45, [
                                        _createElementVNode("span", _hoisted_46, _toDisplayString(ots.description), 1)
                                      ])
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_47, [
                                    _createElementVNode("div", _hoisted_48, [
                                      _hoisted_49,
                                      _createVNode(_component_q_chip, {
                                        color: _ctx.getChipColor(ots.colorCode),
                                        "text-color": "white",
                                        size: "sm",
                                        class: "mt-1 ots-color-chip",
                                        dense: ""
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(ots.colorLabel), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["color"])
                                    ]),
                                    _createElementVNode("div", _hoisted_50, [
                                      _hoisted_51,
                                      _createElementVNode("span", _hoisted_52, _toDisplayString(ots.technicalNoteNumber || '-'), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_53, [
                                      _hoisted_54,
                                      _createElementVNode("span", _hoisted_55, _toDisplayString(ots.quotation || '-'), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_56, [
                                      _hoisted_57,
                                      _createElementVNode("span", _hoisted_58, _toDisplayString(ots.agreement === '1' ? '✓ Oui' : '✗ Non'), 1)
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_59, [
                                    _createElementVNode("div", _hoisted_60, [
                                      _hoisted_61,
                                      _createElementVNode("span", _hoisted_62, _toDisplayString(ots.deliveryCountryCode || '-'), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_63, [
                                      _hoisted_64,
                                      _createElementVNode("span", _hoisted_65, _toDisplayString(_ctx.formatDate(ots.deliveryDate)), 1)
                                    ])
                                  ])
                                ], 2))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}